module.exports = __webpack_public_path__ + "static/img/pro_tab4.d9eaad6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro_tab4.jpg
// module id = 7Cyp
// module chunks = 171